import { P4Regular as P4RegularStyle } from 'theme/typography';
import { Text, TextProps } from '@mantine/core';
import mergeTextSx from 'components/typography/merge-text-sx';

/**
 * Applies the P4Regular typography style.
 */
export default function P4Regular({ sx, ...props }: TextProps) {
  return <Text {...props} sx={mergeTextSx(P4RegularStyle, sx)} />;
}
